<template>
  <!-- <div
    class="header_wrap"
    style="transition: all 0.1s;"
    :style="
      isShowLineBanner
        ? { 'min-height': 170 + 'px' }
        : { 'min-height': 170 + 'px' }
    "
  > -->
  <div>
    <div v-if="isPc" class="header_wrap">
      <QuickNav v-if="scrollPosition > 268 && isQuick"></QuickNav>
      <PresentModal v-if="isShowPresent" @close="togglePresentModal" />
      <div
        v-if="isMobile"
        class="back-color"
        :class="showMobileMenu ? 'back-color-on' : ''"
        @click="closeMobileMenu"
      ></div>
      <transition name="slide-left">
        <MobileSidebar
          v-if="showMobileMenu"
          :class="{ 'show-mobile-menu': showMobileMenu }"
          @close="closeMobileMenu"
        />
      </transition>
      <!-- </div> -->
      <header id="header" :class="{ on_scroll: scrollPosition > 0 }">
        <div class="top_wrap">
          <div class="ham_btn cursor" @click="isTopToggle = !isTopToggle">
            <img src="@/assets/images/header/ham.png" alt="카테고리" />
          </div>
          <TopToggle
            v-if="isTopToggle"
            class="top_toggle"
            @close="isTopToggle = false"
          />
          <div class="logo_box">
            <!-- <a href="/">
              <h1 class="univ_logo logo_web">
                <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
              </h1>
            </a> -->
            <router-link :to="{ name: 'store' }">
              <h1 class="univ_logo logo_web">
                <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
              </h1>
            </router-link>
          </div>
          <div class="search_box">
            <div v-on-clickaway="closeSearchTp" class="select_b cursor">
              <ul :class="{ on: isSearchTpToggle }">
                <li class="target_opt" @click="toggleSearchTp">
                  <span>{{ searchTp }}</span>
                  <img
                    src="../../assets/images/hakji_search_down.png"
                    alt="카테고리 검색"
                  />
                </li>
                <li class="opt_wrap">
                  <ul>
                    <li @click="setSearchTp('통합검색')">통합검색</li>
                    <li @click="setSearchTp('도서명')">도서명</li>
                    <li @click="setSearchTp('저자')">저자</li>
                    <li @click="setSearchTp('출판사')">출판사</li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- pc 검색창 -->
            <input
              ref="search"
              v-model="searchQuery"
              type="text"
              :placeholder="placeholderText"
              class="base_search"
              @keydown="onKeyDown"
              @input="onInputChange"
              @focus="clearPlaceholder"
            />
            <div class="search_ico" @click="handleMoreClick"></div>
            <div
              v-if="searchQuery !== '' && results.length === 0 && !searching"
              class="search_wrap"
            >
              검색 결과가 없습니다
            </div>
            <div
              v-if="searching === true && showSearchModal === false"
              class="search_wrap"
            >
              검색 중 입니다
            </div>
            <div
              v-if="results.length > 0 && showSearchModal === true"
              ref="searchBox"
              class="search_wrap"
            >
              <SearchModal
                :showSearchModal="showSearchModal"
                :searchQuery="searchQuery"
                :searchTp="searchTp"
                :searching="searching"
                :results="results"
                :class="{ 'show-search': showSearchModal }"
                @close="showSearchModal = false"
              />
            </div>
          </div>
          <div class="icon_box">
            <router-link :to="{ name: 'faq' }">
              <span class="an_t service_bt">
                <img
                  src="@/assets/images/header/info_center.png"
                  alt="고객센터"
                />
              </span>
            </router-link>
            <router-link :to="{ name: 'cart' }">
              <span class="an_t cart_bt">
                <img src="@/assets/images/header/cart.png" alt="장바구니" />
              </span>
            </router-link>
            <router-link :to="{ name: 'orders' }">
              <span class="an_t mypage_bt">
                <img
                  src="@/assets/images/header/account.png"
                  alt="마이페이지"
                />
              </span>
            </router-link>
          </div>
        </div>
        <div class="bot_wrap flex-center">
          <nav class="nav_wrap">
            <div id="search_box" class="search_box">
              <!--pad-->
              <input
                v-model="searchQuery"
                type="text"
                placeholder="도서검색"
                class="base_search"
                @keyup.enter="padSearch"
              />
              <div class="search_ico" @click="padSearch"></div>
            </div>
            <div class="l_box">
              <ul v-on-clickaway="toggleCategryClose" class="category_wrap">
                <li
                  class="category_toggle_btn cursor flex-center"
                  style="height: 100%;"
                  @click="toggleCategryList"
                >
                  <div class="menu_icon_wrap">
                    <img src="@/assets/images/header/ham.png" alt="카테고리" />
                  </div>
                  <button>
                    <span class="base_NB18">분야별 도서보기</span>
                  </button>
                </li>
                <li class="category_list" :class="{ active: isCategryToggle }">
                  <!--분야별 도서보기 세부리스트-->
                  <!-- <ul v-if="hasEventBook" class="event">
                    <li style="background-color: greenyellow;">
                      <router-link
                        :to="{
                          name: 'books_event',
                          params: { order: 1 }
                        }"
                        class="catgry-btn flex base_CT16"
                      >
                        이벤트(신학기 도서할인)
                      </router-link>
                    </li>
                  </ul> -->
                  <ul v-if="getCatgryList">
                    <li
                      v-for="(ctgry, i) in getCatgryList"
                      :key="i + 'catgry'"
                      :class="{ on: i === isMouseOver }"
                      @mouseover="mouseoverList(i)"
                      @click="moveCategory(ctgry)"
                    >
                      <span class="catgry-btn flex base_CT16">
                        {{ ctgry.catgryNm }}
                        <span
                          v-if="ctgry.catgryNm != '전체'"
                          class="catgry_desc"
                        >
                          ({{ ctgry.childCnt }})
                        </span>
                      </span>
                      <ul v-if="ctgry.subCatgryList" class="subCatgry_wrap">
                        <li
                          v-for="(subctgry, idx) in ctgry.subCatgryList"
                          :key="idx + 'subctgry'"
                          @click.stop="moveSubCategory(ctgry, subctgry)"
                        >
                          <span class="catgry-btn base_CT16 subcatgry-btn">
                            {{ subctgry.subCatgryNm }}
                            <span class="catgry_desc">
                              ({{ subctgry.childCnt }})
                            </span>
                          </span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="link_tab_list">
                <li class="link_tab_item toLibrary">
                  <router-link
                    :class="{ '': !isRouteLibrary }"
                    :style="
                      !isRouteLibrary
                        ? { 'background-color': 'transparent' }
                        : {}
                    "
                    :to="{
                      name: 'library_default'
                    }"
                  >
                    내서재
                  </router-link>
                </li>
                <li class="link_tab_item toCart">
                  <router-link
                    :class="{ '': !isRouteCart }"
                    :style="
                      !isRouteCart ? { 'background-color': 'transparent' } : {}
                    "
                    :to="{
                      name: 'cart'
                    }"
                  >
                    장바구니
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="r_box">
              <div class="member_wrap">
                <div
                  v-if="getCurrentUser && getCurrentUser.memberTp === '1000'"
                  class="teacher_toggle"
                >
                  <a
                    href="/account/coupon"
                    class="t_t_btn"
                    :class="{ '': !isLoggedIn }"
                  >
                    체험판 코드
                  </a>
                </div>
                <div
                  v-if="!getCurrentUser || getCurrentUser.memberTp === '2000'"
                  v-on-clickaway="toggleTeacherClose"
                  class="teacher_toggle"
                >
                  <div
                    class="t_t_btn teacher_way"
                    :class="{ '': !isLoggedIn }"
                    @click="toggleTeacher"
                  >
                    교강사 전용
                    <div class="teacher_dropdown_arrow">
                      <button class="arrow">
                        <img
                          src="@/assets/images/header/arrow.png"
                          alt="교강사 상세"
                        />
                      </button>
                      <div
                        class="toggle_wrap"
                        :class="{ active: isTeacherToggle }"
                      >
                        <ul class="teacher_list">
                          <li
                            class="teacher_list_item"
                            @click="toggleTeacherClose"
                          >
                            <router-link :to="{ name: 'postPresent' }"
                              ><span>증정코드입력</span></router-link
                            >
                          </li>
                          <li
                            class="teacher_list_item"
                            @click="toggleTeacherClose"
                          >
                            <router-link :to="{ name: 'present' }"
                              ><span>증정요청</span></router-link
                            >
                          </li>
                          <li
                            class="teacher_list_item"
                            @click="toggleTeacherClose"
                          >
                            <router-link :to="{ name: 'GiftRequestGuide' }"
                              ><span>증정요청 가이드</span></router-link
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <router-link
                  v-if="!isLoggedIn"
                  class="rect_btn login-btn"
                  :to="{ name: 'login' }"
                >
                  로그인
                </router-link>
                <router-link
                  v-if="!isLoggedIn"
                  class="rect_btn join-btn"
                  :to="{ name: 'sign_up' }"
                >
                  회원가입
                </router-link>
                <button
                  v-if="isLoggedIn"
                  class="rect_btn logout-btn"
                  @click="logout"
                >
                  로그아웃
                </button>
                <router-link
                  v-if="isLoggedIn"
                  class="rect_btn mypage-btn"
                  :to="{ name: 'orders' }"
                >
                  마이페이지
                </router-link>
              </div>
            </div>
            <div class="mobile_r_box" @click="openMobileMenu"></div>
          </nav>
        </div>
      </header>
      <div class="side_wrap">
        <div class="side_my_box">
          <router-link
            v-if="!isLoggedIn"
            class="rect_btn login-btn"
            :to="{ name: 'login' }"
          >
            <img
              style="margin-right: 4px;"
              src="@/assets/images/side_login.png"
              alt="로그인"
            />
            <span class="">로그인</span>
          </router-link>
          <img
            class="side_close"
            src="@/assets/images/side_close.png"
            alt="닫기"
          />
        </div>
        <div
          class="cursor side_tit_box"
          style="background-color: #007fa2;"
          @click="toggleCategryList"
        >
          <div class="menu_icon_wrap">
            <div class="menu-border"></div>
            <div class="menu-border"></div>
            <div class="menu-border"></div>
          </div>
          <button>
            <span class="base_NB18 white-txt">분야별 도서보기</span>
          </button>
        </div>
        <ul class="side_menu">
          <router-link to="{ name: '' }">
            <li class="active">전체</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>사회과학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>사범 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>법학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>경상 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>공학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>어문학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>예체능 / 문화 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>의약학 / 간호 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>인문학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>자연과학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>기타</li>
          </router-link>
        </ul>
      </div>
      <transition v-on-clickaway="toggleSearchErrModal" name="modal-fade">
        <Modal v-if="showSearchErrModal" @close="toggleSearchErrModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="toggleSearchErrModal"
                  ><span>{{ $t('library.deletemodal.close') }}</span></a
                >
              </div>
              <div class="ly_inner base_NB24 txt_center">
                <p>
                  검색어를 입력하세요.
                </p>
                <div class="btnWrap txt_center">
                  <button class="box_btn" @click="toggleSearchErrModal">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
      <transition v-on-clickaway="toggleLogoutModal" name="modal-fade">
        <Modal v-if="isShowLogout" @close="toggleLogoutModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="toggleLogoutModal">
                  <span>{{ $t('library.deletemodal.close') }}</span>
                </a>
              </div>
              <div class="ly_inner base_NB24 txt_center">
                <p>
                  로그아웃 하시겠습니까?
                </p>
                <div class="btnWrap txt_center">
                  <button class="box_btn mr-1" @click="logout">
                    <span class="an_t">확인</span>
                  </button>
                  <button class="box_btn" @click="toggleLogoutModal">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
    </div>
    <div v-if="isMobile">
      <PresentModal v-if="isShowPresent" @close="togglePresentModal" />
      <div
        class="back-color"
        :class="showMobileMenu ? 'back-color-on' : ''"
        @click="closeMobileMenu"
      ></div>
      <section v-show="showSearchModal">
        <div class="sm_wrap">
          <div class="inner">
            <form class="form_class" @submit.prevent>
              <div class="search_img">
                <img src="@/assets/images/mobile_main/search.png" alt="검색" />
              </div>
              <input
                id="search_box"
                type="text"
                class="searchbox"
                placeholder="제목, 저자, 출판사 검색"
                @input="onInputChange"
                @keyup.enter="handleMoreClick"
              />
              <label for="search_box"></label>
            </form>
            <div
              v-if="searchQuery === '' && results.length === 0 && !searching"
              class="default_result"
            >
              <span class="guide">검색어를 입력해 주세요.</span>
            </div>
            <div
              v-if="searchQuery !== '' && results.length === 0 && !searching"
              class="default_result"
            >
              <span class="guide">검색결과가 없습니다.</span>
            </div>
            <SearchModal
              v-if="showSearchModal"
              :showSearchModal="showSearchModal"
              :searchQuery="searchQuery"
              :searchTp="searchTp"
              :searching="searching"
              :results="results"
              :class="{ 'show-search': showSearchModal }"
              @close="closeSearchModal"
            />
          </div>
        </div>
        <div class="search_cover" @click="disNonSearch"></div>
      </section>
      <header
        v-if="$route.name != 'book_detail'"
        id="header_main"
        class="mobile_header"
        :class="{
          posFixed: $route.name != 'book_detail' && scrollPosition > 0
        }"
      >
        <h1 class="logo">
          <a href="/">
            <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
          </a>
        </h1>
        <nav class="hd_right">
          <router-link v-if="!isLoggedIn" class="login" :to="{ name: 'login' }">
            로그인
          </router-link>
          <router-link
            v-if="isLoggedIn"
            class="login"
            :to="{ name: 'library_default' }"
          >
            내 서재
          </router-link>
          <i class="search" @click="openSearchModal"
            ><img src="@/assets/images/search.png" alt="검색"
          /></i>
          <i class="ham_icon" @click="openMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </i>
        </nav>
      </header>
      <header
        v-if="$route.name == 'book_detail'"
        id=""
        class="mobile_header detail_hd"
        :class="{
          'down': !isHeadVisible,
          'bgchange': isBgChanged
        }"
      >
        <div class="hd_left">
          <i class="back_button" @click="goBack">
            <img src="@/assets/images/head_detail/back.png" alt="뒤로가기" />
          </i>
          <router-link to="/">
            <img src="@/assets/images/head_detail/home.png" alt="메인" />
          </router-link>
        </div>
        <h1 class="detail_logo">
          <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
        </h1>
        <div class="hd_right">
          <router-link to="/cart">
            <img src="@/assets/images/head_detail/cart.png" alt="장바구니" />
          </router-link>
          <i class="search" @click="openSearchModal"
            ><img src="@/assets/images/head_detail/search.png" alt="검색"
          /></i>
        </div>
      </header>
      <div class="side_wrap">
        <div class="side_my_box">
          <router-link
            v-if="!isLoggedIn"
            class="rect_btn base_NB18 login-btn"
            :to="{ name: 'login' }"
          >
            <img
              style="margin-right: 4px;"
              src="@/assets/images/side_login.png"
              alt="로그인"
            />
            <span class="">로그인</span>
          </router-link>
          <img
            class="side_close"
            src="@/assets/images/side_close.png"
            alt="닫기"
          />
        </div>
        <div
          class="cursor side_tit_box"
          style="background-color: #007fa2;"
          @click="toggleCategryList"
        >
          <div class="menu_icon_wrap">
            <div class="menu-border"></div>
            <div class="menu-border"></div>
            <div class="menu-border"></div>
          </div>
          <button>
            <!-- <span class="ham_logo"></span> -->
            <span class="base_NB18 white-txt">분야별 도서보기</span>
          </button>
        </div>
        <ul class="side_menu">
          <router-link to="{ name: '' }">
            <li class="active">전체</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>사회과학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>사범 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>법학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>경상 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>공학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>어문학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>예체능 / 문화 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>의약학 / 간호 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>인문학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>자연과학 계열</li>
          </router-link>
          <router-link to="{ name: '' }">
            <li>기타</li>
          </router-link>
        </ul>
      </div>
      <transition name="modal-fade">
        <MobileSidebar
          v-if="showMobileMenu"
          :class="{ 'show-mobile-menu': showMobileMenu }"
          @close="closeMobileMenu"
        />
      </transition>
      <transition v-on-clickaway="toggleSearchErrModal" name="modal-fade">
        <Modal v-if="showSearchErrModal" @close="toggleSearchErrModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="toggleSearchErrModal"
                  ><span>{{ $t('library.deletemodal.close') }}</span></a
                >
              </div>
              <div class="ly_inner base_NB24 txt_center">
                <p>
                  검색어를 입력하세요.
                </p>
                <div class="btnWrap txt_center">
                  <button class="box_btn" @click="toggleSearchErrModal">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
      <transition v-on-clickaway="toggleLogoutModal" name="modal-fade">
        <Modal v-if="isShowLogout" @close="toggleLogoutModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="toggleLogoutModal"
                  ><span>{{ $t('library.deletemodal.close') }}</span></a
                >
              </div>
              <div class="ly_inner base_NB24 txt_center">
                <p>로그아웃 하시겠습니까?</p>
                <div class="btnWrap txt_center">
                  <button class="box_btn mr-1" @click="logout">
                    <span class="an_t">확인</span>
                  </button>
                  <button class="box_btn" @click="toggleLogoutModal">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  STORE_CATEGORIES_GET_LIST,
  STORE_EVENT_CATEGORIES_GET,
  SEARCH_LIST_PREVIEW,
  AUTH_LOGOUT
} from '@/store/types'
import {
  universityName,
  useAliceLogo,
  hideSelfbook,
  isNiaMode
} from '@/store/constants'
import PresentModal from '@/components/library/PresentModal.vue'
import MobileSidebar from './MobileSidebar.vue'
import TopToggle from '@/components/common/CategryToggle.vue'
import QuickNav from './QuickNav.vue'
import SearchModal from './SearchModal.vue'
export default {
  name: 'Header',
  components: {
    MobileSidebar,
    PresentModal,
    TopToggle,
    QuickNav,
    SearchModal
  },
  props: {
    isSearch: Boolean
  },
  data() {
    return {
      searchTp: '통합검색',
      isSearchTpToggle: false,
      isTopToggle: false,
      isMouseOver: null,
      scrollPosition: null,
      showMobileMenu: false,
      showSearchModal: false,
      showSearchErrModal: false,
      universityName,
      useAliceLogo,
      hideSelfbook,
      isNiaMode,
      isTeacherToggle: false,
      isCategryToggle: false,
      // search: '',
      isShowPresent: false,
      isShowLogout: false,
      isPc: false,
      isMobile: false,
      isHeadVisible: true,
      lastScrollPosition: 0,
      abTestingBook: [
        {
          name: '성인간호학 [2판] I, II권 세트 e-Book only 10% 할인!',
          cd: 'BO-20240826000100001'
        },
        {
          name: '성인간호학 I [2판] e-Book only 10% 할인!',
          cd: 'BO-20240823000100003'
        },
        {
          name: '성인간호학 II [2판] e-Book only 10% 할인!',
          cd: 'BO-20240823000100002'
        },
        {
          name: '커리어 코칭의 이론과 실제(2판) 대여 6개월 20%할인!',
          cd: 'BO-20241008000100006'
        },
        {
          name: '심리평가의 최신 흐름(2판) 22% 대여 할인',
          cd: 'BO-20220318000100049'
        },
        {
          name: '특수아동교육 4판 20% 대여 할인',
          cd: 'BO-20240305000100075'
        },
        {
          name: '즐거운 갓생 생활 중국어 캠퍼스북 e-Book only!',
          cd: 'BO-20240227000100019'
        }
      ],
      placeholderText: '',
      placeholderCd: '',
      isBgChanged: false,
      results: [],
      searchTimeout: null,
      searching: false,
      searchQuery: '' // 검색어를 저장
    }
  },
  computed: {
    ...mapGetters([
      'isSidebarOpen',
      'isAuthLoading',
      'getCurrentUser',
      'getMainCategories',
      'getMainSubcategories',
      'getMainEventCategories',
      'isShowLineBanner'
    ]),
    isQuick() {
      return this.$route.name === 'store' || this.$route.name === 'book_detail'
        ? true
        : false
    },
    calcHeaderHeight() {
      return !this.scrollPosition || 0
        ? { 'min-height': 98 + 'px' }
        : { 'min-height': 170 + 'px' }
    },
    isLoggedIn() {
      return this.getCurrentUser
    },
    getCatgryList() {
      return this.getMainCategories || []
    },
    getSubCatgryList() {
      return this.getMainSubCategories || []
    },
    isRouteLibrary() {
      return this.$route.path.includes('/library')
    },
    isRouteCart() {
      return this.$route.path.includes('/cart')
    },
    isTeacher() {
      if (!this.isLoggedIn || this.getCurrentUser?.memberTp !== 2000)
        return false
      return true
    },
    hasEventBook() {
      if (this.getMainEventCategories?.count > 0) {
        return true
      }
      return false
    },
    totalCatgryHeight() {
      return this.getCatgryList.length * 32 + 32
    }
  },
  watch: {
    isSearch(newVal) {
      if (!newVal) {
        // this.search = ''
        this.searchQuery = ''
        this.setRandomPlaceholder()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.setRandomPlaceholder()
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
    window.addEventListener('scroll', this.headScroll)
    !this.getMainCategories && this.$store.dispatch(STORE_CATEGORIES_GET_LIST)
    !this.getMainEventCategories &&
      this.$store.dispatch(STORE_EVENT_CATEGORIES_GET)
    return window.addEventListener('scroll', this.updateScroll)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('scroll', this.headScroll)
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth >= 481
      this.isMobile = window.innerWidth <= 480
    },
    closeSearchTp() {
      this.isSearchTpToggle = false
    },
    toggleSearchTp() {
      this.isSearchTpToggle = !this.isSearchTpToggle
    },
    setSearchTp(tp) {
      this.searchTp = tp
      this.closeSearchTp()
    },
    async logout() {
      // this.toggleLogoutModal()
      // console.log(this.$route)
      await this.$store.dispatch(AUTH_LOGOUT)
      // this.$router.go(this.$route.currentRoute)
      if (this.$route.path === '/') {
        this.$router.go(this.$route.currentRoute)
      } else {
        this.$router.push('/')
      }
    },
    toggleCategryList() {
      this.isCategryToggle = !this.isCategryToggle
      this.isMouseOver = null
    },
    toggleLogoutModal() {
      this.isShowLogout = !this.isShowLogout
    },
    toggleSearchErrModal() {
      this.showSearchErrModal = !this.showSearchErrModal
      this.$refs.search.focus()
    },
    toggleCategryClose() {
      if (!this.isCategryToggle) return

      this.isCategryToggle = false
    },
    closeTopBanner() {
      this.$store.dispatch('closeTopBanner')
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    openMobileMenu() {
      this.showMobileMenu = true
    },
    openSearchModal() {
      this.showSearchModal = true
    },
    closeSearchModal() {
      this.showSearchModal = false
    },
    closeMobileMenu() {
      this.showMobileMenu = false
    },
    toggleTeacher() {
      this.isTeacherToggle = !this.isTeacherToggle
    },
    toggleTeacherClose() {
      this.isTeacherToggle = false
    },
    sendToLogin() {
      this.$router.push({ name: 'login' })
    },
    clearPlaceholder() {
      this.placeholderText = ''
      this.placeholderCd = ''
    },
    setRandomPlaceholder() {
      const randomIndex = Math.floor(Math.random() * this.abTestingBook.length)
      const { name, cd } = this.abTestingBook[randomIndex]
      this.placeholderText = name
      this.placeholderCd = cd
      // this.placeholderText = '검색어를 입력해 주세요'
    },
    handleClickOutside(event) {
      // searchBox와 클릭된 영역이 같은지 확인
      if (
        this.$refs.searchBox &&
        !this.$refs.searchBox.contains(event.target)
      ) {
        this.showSearchModal = false
      }
    },
    onKeyDown(event) {
      const key = event.key

      if (this.searching && key === 'Enter') {
        // this.handleMoreClick() // 엔터 키 입력 시 검색 실행
        return // 검색 중일 때 엔터 입력 무시
      }

      // 엔터 키 입력이 감지되었을 때
      if (key === 'Enter') {
        this.showSearchModal = false // 엔터 입력 시 모달을 닫음
        this.handleMoreClick() // 엔터 입력 시 검색 실행
        return
      }
      if (
        key === 'ArrowLeft' ||
        key === 'ArrowRight' ||
        key === 'ArrowUp' ||
        key === 'ArrowDown'
      ) {
        return
      }
    },
    onInputChange(event) {
      const newValue = event.target.value

      // 값이 변경되지 않았으면 실행하지 않음 (방향키로 인한 변화 방지)
      if (this.searchQuery === newValue) {
        return
      }
      this.searchQuery = newValue
      this.startSearchWithDelay() // 검색 딜레이 적용 후 검색 실행
    },
    startSearchWithDelay() {
      // 검색 중임을 표시
      this.searching = true
      // 이전 타이머가 있다면 취소
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      // 새로운 타이머 설정
      this.searchTimeout = setTimeout(() => {
        this.performSearch()
      }, 300) // 300ms 딜레이
    },
    async performSearch() {
      this.searching = true // 검색 중임을 표시
      if (this.searchQuery.length >= 2) {
        try {
          await this.searchTermPc(this.searchQuery)
          // if (!this.searchingByEnter) {
          // 엔터로 인한 검색이라면 모달 열지 않음
          // this.showSearchModal = this.results.length > 0 // 검색 결과가 있을 때만 모달 열기
          // }
        } catch (error) {
          console.error('검색 중 오류 발생:', error)
        } finally {
          this.searching = false // 검색이 완료되면 검색 상태 해제
        }
      } else {
        this.resetSearch() // 검색어가 2글자 미만일 경우 검색을 초기화
      }
      // if (this.isPc) {
      //   if (this.searchQuery.length >= 2) {
      //     await this.searchTermPc(this.searchQuery)
      //     this.showSearchModal = this.results.length > 0
      //   } else {
      //     this.resetSearch()
      //   }
      // } else {
      //   if (this.searchQuery.length >= 2) {
      //     await this.searchTermPc(this.searchQuery)
      //     this.showSearchModal = this.results.length > 0
      //   } else {
      //     this.searching = false
      //     this.results = []
      //   }
      // }
    },
    async searchTermPc(query) {
      try {
        const response = await this.$store.dispatch(SEARCH_LIST_PREVIEW, {
          searchKeyword: query,
          searchTp2: this.searchTp
        })
        this.results = response.data?.result?.bookList ?? []

        this.showSearchModal = this.results.length > 0
      } catch (error) {
        console.error('검색 중 오류 발생:', error)
      } finally {
        // 검색이 끝났음을 표시
        this.searching = false
      }
    },
    handleMoreClick() {
      // searchQuery에 값이 없을 경우 placeholderText를 사용
      if (this.searchQuery.trim() === '') {
        this.$router.push({
          name: `book_detail`,
          params: { id: this.placeholderCd }
        })
      } else {
        this.showSearchModal = false
        this.$set(this, 'showSearchModal', false)

        this.doSearch()
        // this.searching = false
        //포커스를 즉시 제거
        const inputElement = this.$refs.search
        if (inputElement) {
          inputElement.blur()
        }
      }
    },
    padSearch() {
      if (this.search === '') {
        this.toggleSearchErrModal()
        return
      }
      this.doSearch()
    },
    async doSearch() {
      await this.$store.dispatch('fetchSearchList', {
        searchKeyword: this.searchQuery,
        searchTp2: this.searchTp
      })
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.searchQuery,
          searchTp: this.searchTp
        }
      })
    },
    resetSearch() {
      // this.searchQuery = '' // 검색 키워드 초기화
      if (this.isPc) {
        this.showSearchModal = false // 검색 박스 닫기
      }
      this.results = [] // 검색 결과 초기화
      this.searching = false // 검색 중 상태 초기화
    },
    togglePresentModal() {
      this.isTeacherToggle = false
      this.isShowPresent = !this.isShowPresent
    },
    mouseoverList(i) {
      this.isMouseOver = i
    },
    moveCategory(ctgry) {
      if (ctgry.catgryCd == 'A' || !ctgry.subCatgryList.length) {
        this.isCategryToggle = false
        this.isMouseOver = null
        this.$router.push({
          name: 'category_books',
          params: {
            category: ctgry.catgryCd,
            subCategory: ctgry.catgryCd
          }
        })
      } else {
        this.$router.push({
          name: 'category_books',
          params: {
            category: ctgry.catgryCd,
            subCategory: ctgry.catgryCd
          }
        })
      }
    },
    moveSubCategory(ctgry, subctgry) {
      this.$router.push({
        name: 'category_books',
        params: {
          category: 'null',
          subCategory: 'null',
          subCategoryNm: 'null'
        }
      })
      this.$router.push({
        name: 'category_books',
        params: {
          category: ctgry.catgryCd,
          subCategory: subctgry.subCatgryCd,
          subCategoryNm: subctgry.subCatgryNm
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    headScroll() {
      // 현재 스크롤 위치
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      // 스크롤 방향을 비교하여 요소의 가시성을 제어
      if (currentScrollPosition > this.lastScrollPosition) {
        // 스크롤을 내릴 때 (Down)
        this.isHeadVisible = false
      } else {
        // 스크롤을 올릴 때 (Up)
        this.isHeadVisible = true
      }
      // bgchange 클래스 적용 여부 결정
      if (currentScrollPosition > 0) {
        this.isBgChanged = true
      } else {
        this.isBgChanged = false
      }
      // 현재 스크롤 위치를 업데이트
      this.lastScrollPosition =
        currentScrollPosition <= 0 ? 0 : currentScrollPosition
    },
    disNonSearch() {
      this.showSearchModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
.header_wrap {
  position: relative;
  transition: all 0.1s;
  min-height: 170px;
}
.search_ico {
  background-image: url('../../assets/images/hakji_search_ico.svg');
  width: 32px;
  background-repeat: no-repeat;
  background-position-x: 98%;
  background-position-y: center;
  background-size: 28px;
  font-size: 1.2rem;
  cursor: pointer;
}
.show-mobile-menu {
  right: 0;
}
.back-color {
  background-color: black;
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  display: none;
  transition: all 0.5s;
  z-index: 1000;
}
#header {
  .search_box {
    position: static;
    flex-grow: 1;
    height: 48px;
    transform: translateX(0);
    margin-left: 35px;
    margin-right: 107px;
    .select_b {
      position: relative;
      display: inline-flex;
      align-items: center;
      min-width: 110px;
      height: 100%;
      padding: 0px 15px;
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 7px;
        transform: translateY(-50%);
        width: 1px;
        height: 12px;
        background-color: #d5d5d5;
      }
      .target_opt {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        width: 100%;
        height: 100%;
        > img {
          margin-right: 4px;
          aspect-ratio: auto 4 / 3;
        }
      }
      ul {
        width: 100%;
        height: 100%;
      }
      .opt_wrap {
        position: absolute;
        bottom: -160px;
        left: -2px;
        z-index: 99;
        display: none;
        width: calc(100% + 4px);
        height: 0;
        padding: 10px 0;
        background-color: #ffffff;
        border: 1px solid #d5d5d5;
        border-radius: 15px;
        li {
          padding: 8px 26px;
          font-size: 14px;
          &:hover {
            background-color: #e1f2ff;
            text-decoration: underline;
          }
        }
      }
      > ul.on {
        .opt_wrap {
          height: auto;
          display: block;
        }
        .target_opt {
          > img {
            transform: rotate(-180deg);
          }
        }
      }
    }
  }
  .top_wrap {
    position: relative;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    max-width: 1120px;
    height: 110px;
    margin: auto;
  }
  .bot_wrap {
    width: 100%;
    height: 60px;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    justify-content: center;
    .nav_wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1120px;
    }
  }
}
.search_box {
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  display: flex;
  max-width: 550px;
  // height: 40px;
  padding: 0px 12px 0px 0px;
  border: 1px solid #d5d5d5;
  border-radius: 30px;
}
.search_wrap {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  padding: 25px 25px;
  background-color: #fff;
  border: 1px solid #999;
  box-sizing: border-box;
  li {
    margin-bottom: 10px;
    &.more {
      text-align: center;
      span {
        display: inline-block;
        padding: 12px 38px;
        border: 1px solid #727272;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 600;
        color: #231815;
        cursor: pointer;
      }
    }
    figure {
      display: flex;
      align-items: center;
      gap: 15px;
      img {
        width: 108px;
        height: 150px;
        border: 1px solid #727272;
      }
      figcaption {
        span {
          display: block;
          width: 145px;
          word-break: keep-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          &:first-child {
            margin-bottom: 12px;
            line-height: 21px;
            font-family: 'pretendard-medium';
            font-size: 18px;
          }
          &:last-child {
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
  }
}
// #search_box {
//   .base_search::placeholder {
//     color: $white;
//     opacity: 0.5;
//   }
// }
.icon_box {
  display: flex;
  gap: 27px;
  .cart_bt {
    margin-left: -5px;
  }
  a {
    img {
      width: 45px;
      aspect-ratio: auto 1 / 1;
      vertical-align: middle;
    }
  }
}
.top_wrap {
  .logo_box {
    flex: 0;
    padding-left: 0px;
    .logo_mobile {
      display: none;
    }
  }
  .ham_btn {
    display: none;
    width: 50px;
    height: 48px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.bot_wrap {
  .search_box {
    display: none;
  }
  .nav_wrap {
    .category_wrap {
      position: relative;
      height: 60px;
      padding: 0 20px 0 0;
      .category_list {
        display: none;
        position: absolute;
        top: 59px;
        left: 0;
        width: 100%;
        background-color: #fff;
        border: 1px solid #eaeaea;
        border-radius: 6px;
        box-sizing: border-box;
        transition: all 0.2s;
        &.active {
          display: inline-block;
          animation: fadeInDown 0.2s both;
          -webkit-transform-origin: 50% 0%;
        }
        > ul {
          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: $h_sub_blue;
            border-radius: 10px;
            background-clip: padding-box;
            border: 1px solid transparent;
          }
          &::-webkit-scrollbar-track {
            background-color: grey;
            box-shadow: inset 0px 0px 5px white;
          }
        }
        .event {
          li {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }
        }
        li {
          padding: 2px 12px;
          color: #000;
          .catgry-btn {
            min-height: 36px;
            align-items: center;
            .catgry_desc {
              font-size: 13px;
              color: $h_nav_color;
            }
          }
          span {
            cursor: pointer;
          }
        }
        li:hover {
          background-color: #eaeaea;
        }
        li.on {
          background-color: #eaeaea;
        }
      }
      .menu_icon_wrap {
        width: 40px;
        height: 38px;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .mobile_r_box {
      display: none;
      cursor: pointer;
      background-image: url('../../assets/images/hakji_mobile_btn.svg');
      background-color: #0b405b;
      background-position: center;
      background-repeat: no-repeat;
    }
    .link_tab_list {
      display: flex;
      align-items: center;
      .link_tab_item {
        height: 100%;
        a {
          display: block;
          height: 100%;
          padding: 0 24px;
          line-height: 60px;
          font-family: 'pretendard-medium';
          font-size: 18px;
          color: $h_nav_color;
        }
      }
    }
    .member_wrap {
      display: flex;
      height: 60px;
      align-items: center;
      .teacher_toggle {
        .t_t_btn {
          padding: 0 24px;
          line-height: 60px;
          font-size: 18px;
          font-family: 'pretendard-medium';
          color: $h_nav_color;
          &.teacher_way {
            display: flex;
            align-items: center;
            gap: 7px;
            cursor: pointer;
          }
        }
        .teacher_dropdown_arrow {
          position: relative;
          width: 28px;
          height: 28px;
          .arrow {
            display: inline-block;
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .toggle_wrap {
          display: none;
          position: absolute;
          top: 43px;
          right: 0;
          width: 125px;
          height: auto;
          overflow: hidden;
          background-color: #fff;
          border: 1px solid #eaeaea;
          border-radius: 6px;
          transition: all 0.2s;
          .teacher_list {
            li {
              margin: 21px 0;
              padding-left: 12px;
              color: $h_nav_color;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
              span {
                font-size: 16px;
                font-family: 'pretendard-medium';
              }
            }
          }
        }
        .active {
          display: inline-block;
          animation: fadeInDown 0.2s both;
          -webkit-transform-origin: 50% 0%;
        }
      }
      &:last-child {
        margin: 0;
      }
      .rect_btn,
      .join-btn,
      .mypage-btn {
        padding: 0 24px;
        line-height: 60px;
        font-size: 18px;
        font-family: 'pretendard-medium';
        color: $h_nav_color;
      }
      .join-btn,
      .mypage-btn {
        padding: 0 0 0 24px;
      }
    }
  }
}
.btnWrap {
  margin-top: 24px;
  display: flex;
}
.subCatgry_wrap {
  display: none;
  position: absolute;
  top: 0;
  left: 178px;
  width: -moz-available;
  width: -webkit-fill-available;
  width: 210px;
  max-height: 480px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #eaeaee;
}
.subCatgry_wrap::-webkit-scrollbar {
  width: 5px;
}
.subCatgry_wrap::-webkit-scrollbar-thumb {
  background-color: $h_sub_blue;
  border-radius: 10px;
  background-clip: padding-box;
  border: 1px solid transparent;
}
.subCatgry_wrap::-webkit-scrollbar-track {
  background-color: grey;
  box-shadow: inset 0px 0px 5px white;
}
.category_list > ul > li.on > ul {
  display: block;
}
.subcatgry-btn {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 35px;
}
.l_box {
  display: flex;
  ul {
    .link_tab_item {
      a {
        img {
          padding-right: 7px;
          width: 30px;
        }
      }
    }
  }
}
.side_wrap {
  display: none;
  position: fixed;
  left: 0px;
  top: 0;
  z-index: 999;
  width: 254px;
  height: 100vh;
  border-right: #aaa 1px solid;
  background-color: #fff;
  .side_my_box {
    padding: 20px;
    img {
      vertical-align: top;
      padding-right: 10px;
    }
    span {
      font-size: 18px;
      line-height: 31px;
    }
    .side_close {
      position: absolute;
      right: 10px;
      top: 25px;
      cursor: pointer;
    }
  }
  .side_tit_box {
    padding: 20px;
    .menu_icon_wrap {
      width: 22px;
      height: 17px;
      display: flex;
      float: left;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 17px;
      .menu-border {
        background-color: #ffffff;
        min-height: 3px;
        border-radius: 2px;
      }
      .menu-border:nth-child(1) {
        width: 25px;
      }
      .menu-border:nth-child(2) {
        width: 21px;
      }
      .menu-border:nth-child(3) {
        width: 17px;
      }
    }
  }
  .side_menu {
    padding: 7px 20px;
    font-size: 18px;
    color: #757575;
    li {
      padding: 13px 0;
    }
    li:hover {
      color: #007fa2;
      font-weight: 700;
    }
    li.active {
      color: #007fa2;
      font-weight: 700;
    }
  }
}
.top_toggle {
  display: none;
}
@media screen and (min-width: 1024px) and (max-width: 1920px) {
  #header {
    &.on_scroll {
      .top_wrap {
        justify-content: flex-start;
        .ham_btn {
          display: block;
          margin-right: 20px;
        }
        .top_toggle {
          display: block;
          bottom: -110px;
          left: 0;
        }
        .logo_box {
          .univ_logo > img {
            max-width: 13.5vw;
            // min-width: 160px;
          }
        }
        .search_box {
          margin-left: 1.8125vw;
          margin-right: 107px;
        }
        .icon_box {
          // margin-left: 1.5625vw;
          // margin-right: 1rem;
        }
      }
      .bot_wrap {
        transition: 0.3s;
        overflow: hidden;
        height: 0;
        border-bottom: none;
      }
    }
  }
}

@media (max-width: 1024px) {
  #header {
    .icon_box {
      display: none;
    }
    .bot_wrap {
      .nav_wrap {
        padding: 0 0 0 34px;
        .l_box {
          .link_tab_list {
            display: flex;
          }
        }
        .r_box {
          display: none;
        }
        .mobile_r_box {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          width: 60px;
          height: 60px;
        }
      }
    }
    .top_wrap {
      justify-content: flex-start;
      .logo_box {
        padding-left: 33px;
      }
    }
    .search_box {
      margin-left: 34px;
    }
  }
}
@media (max-width: 768px) {
  .header_wrap {
    min-height: 108px;
  }
  #header {
    .top_wrap {
      justify-content: center;
      height: 75px;
      .search_box {
        display: none;
      }
      .logo_box {
        padding-left: 0;
        .univ_logo {
          font-size: 21px;
        }
        .logo_web {
          img {
            max-width: 175px;
          }
        }
      }
    }
    .bot_wrap {
      height: 47px;
      border-bottom: 1px solid #eaeaea;
      .search_box {
        position: static;
        flex-grow: 1;
        display: flex;
        transform: translateX(0);
        max-width: 712px;
        margin: 0;
        padding: 4px 0px;
        border: none;
        .base_search {
          width: 95%;
          margin: 10px 8px;
          padding-left: 10px;
          border: none;
          color: #5b5b5b;
          &::placeholder {
            opacity: 0.5;
            color: $h_nav_color;
          }
        }
        .search_ico {
          width: 48px;
          background-position: center center;
        }
      }
      .nav_wrap {
        padding: 0;
        .category_wrap {
          display: none;
        }
        .l_box {
          .link_tab_list {
            margin: 0;
            .link_tab_item {
              width: 100px;
              img {
                display: none;
              }
              a {
                line-height: 48px;
              }
            }
            .toCart {
              display: none;
            }
          }
        }
        .r_box {
          display: none;
        }
        .mobile_r_box {
          display: flex;
          width: 48px;
          justify-content: center;
          align-items: center;
          height: 48px;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  .mobile_header {
    position: static;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    padding: 15px 14px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #cccccc;
    transition: 0.3s;
    opacity: 1;
    visibility: visible;
    &.posFixed {
      position: fixed;
    }
    &.detail_hd {
      position: fixed;
      background-color: #dce5ed;
      border-bottom: 1px solid transparent;
      .hd_left {
        display: flex;
        align-items: center;
        gap: 13px;
      }
      .detail_logo {
        width: 126px;
        height: 25px;
        margin: 0;
      }
      img {
        width: 100%;
        height: 100%;
        image-rendering: -webkit-optimize-contrast;
        transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      }

      .hd_right {
        gap: 15px;
        .search {
          width: auto;
          height: auto;
        }
      }
    }
    &.down {
      opacity: 0;
      visibility: hidden;
      background-color: #dce5ed;
    }
    &.bgchange {
      background-color: #fff;
      border-bottom: 1px solid #cccccc;
    }
  }
  .logo {
    margin: 0;
    width: 160px;
    height: 31px;
    > a {
      display: block;
      width: 100%;
      height: 100%;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .hd_right {
    display: flex;
    align-items: center;
    gap: 20px;
    .login {
      font-family: 'pretendard-medium';
      font-size: 17px;
      color: #125b82;
    }
    .search {
      display: block;
      width: 16px;
      height: 19px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .ham_icon {
      display: block;
      width: 26px;
      span {
        display: block;
        width: 100%;
        height: 1px;
        margin-bottom: 9px;
        background-color: #125b82;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  // 모바일 검색 스타일
  .show-search {
    transition: 0s;
    overflow: hidden;
  }
  .search_cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(19, 19, 19, 0.3);
    z-index: 100;
    opacity: 0.3;
    overflow: hidden;
  }
  .sm_wrap {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 300px;
    opacity: 1;
    background-color: #fff;
    .inner {
      padding: 20px 20px 25px;
    }
  }
  .form_class {
    position: relative;
  }
  .searchbox {
    width: 100%;
    height: 64px;
    padding-left: 60px;
    padding-right: 40px;
    background-color: #f5f6f7;
    border-radius: 30px;
    border: none;
    outline: none;
    font-size: 16px;
    color: #131313;
    &::placeholder {
      color: #5e5e5e;
    }
  }
  .search_img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    width: 38px;
    height: 38px;
    border-radius: 100%;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .default_result span {
    font-size: 18px;
    &.result_ment {
      font-size: 18px;
      color: rgba(48, 48, 48, 0.5);
    }
    &.guide {
      display: block;
      margin-top: 52px;
      margin-bottom: 79px;
      text-align: center;
      color: rgb(151 151 151);
    }
  }
}
</style>
